import React from 'react';
import PropTypes from 'prop-types';

import { Button, Modal } from 'components/ui';

import * as Styled from './GeneralErrorMessageModal.styles';

export const GeneralErrorMessageModal = ({ onClose, onConfirm, title="Błąd", closeText="OK",
  message="Wystąpił nieoczekiwany błąd, ponów akcję lub spróbuj później." }) => {
  return (
    <Modal title={title} onClose={onClose} sx={{ width: 600 }}>
      <Styled.Message>
        {message}
      </Styled.Message>

      <Styled.Actions>
        <Button onClick={onConfirm} variant="outlined">
          {closeText}
        </Button>
      </Styled.Actions>
    </Modal>
  );
};

GeneralErrorMessageModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
};
